import type { ClaraConfiguration } from '../../schemas/clara-configuration';

/**
 * Clara, the claims agent (CUR-1160). The runner's constants: the org flag that is its only
 * switch, the platform prompt it runs on, the triggers that may wake it and the bounds on a run.
 * The trigger pipeline (CUR-1161) adds the debounce window and the org's enablement default.
 */

/** The org-level PostHog flag. Off by default; the job checks it before anything else. */
export const ENABLE_CLARA_FLAG = 'enable-clara';

/** The platform prompt row (`AiPrompt.key` at the system console) the runner loads. */
export const CLARA_PROMPT_KEY = 'clara_claim_base';

export const CLARA_TRIGGERS = ['claim.created', 'reserve.created', 'backstop', 'manual'] as const;
export type ClaraTrigger = (typeof CLARA_TRIGGERS)[number];

/** Runs per claim per UTC day before the runner skips; measured in the PoC, tune later. */
export const CLARA_MAX_RUNS_PER_CLAIM_PER_DAY = 10;

/** Model steps per run: a step is one model turn that may call several tools. */
export const CLARA_MAX_STEPS = 6;

/** Debounce: a run starts this long after the first event on a claim; later events within the window fold into it. */
export const CLARA_RUN_DEBOUNCE_MS = 30_000;

/** The org's Clara enablement (`ORG_SETTING.CLARA_CONFIGURATION`). `enabledFrom` null = not enabled, whatever the flag says. */
export const DEFAULT_CLARA_CONFIGURATION = { enabledFrom: null } as const satisfies ClaraConfiguration;
